import { LaneType } from 'common-types';
import {
  ChannelLanguagesType,
  EnabledLanguagesForMembersType,
} from '../ChannelType';

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use RequirementFeatureContentInteractionProperties from application-types instead.
 */
export type RequirementFeatureContentInteractionProperties = {
  _id: LaneType.UUID;
  content: {
    _id: string;
  };
  header: string;
  description: string;
};

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use RequirementsSource from application-types instead.
 */
export type RequirementsSource = {
  slug: string;
  profileName: string;
  _id: LaneType.UUID;
};

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use RequirementsFeatureProperties from application-types instead.
 */
export type RequirementsFeatureProperties = {
  source?: RequirementsSource;
  profilePictureRequired: boolean;
  multiLanguageEnabled?: boolean;
  channelLanguages?: ChannelLanguagesType;
  enabledLanguagesForMembers?: EnabledLanguagesForMembersType;
  fullNameRequired: boolean;
  phoneNumberRequired: boolean;
  companyNameRequired: boolean;
  verifiedEmailRequired?: boolean;
  contentInteractionRequired: RequirementFeatureContentInteractionProperties[];
};

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use RequirementsEnum from application-types instead.
 */
export enum RequirementsEnum {
  ProfilePicture = 'Profile Picture',
  VerifiedEmail = 'Verified Email',
  FullName = 'Full Name',
  PhoneNumber = 'Phone Number',
  CompanyName = 'Company Name',
  ContentInteraction = 'Content Interaction',
}
